export enum SharedReportApiErrorEnum {
    titleDuplicate = 'SHARED-REPORT-001', // the shared report title is already used
}
